export default __webpack_public_path__ + "static/media/mcw_anydesk.82968ae9.exe";